import './DropDownMultiselect.css';
import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { addQueryStringMultiple } from '../../../Listing';
import { ReactComponent as IconChevronDown } from "../../../../resources/icons/IconChevronDown.svg";
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../../resources/icons/IconArrowRight.svg';
import { get, canUseDOM } from '../../../../utils';
const commonStyles = "cbf3x4i";
const ltrStyles = "l1xkn766";
const rtlStyles = "r1bq1qlk";
const createFacets = (tagsToDisplay, facetValues) => {
  let filteredOptions = [];
  if (facetValues) {
    filteredOptions = tagsToDisplay && tagsToDisplay.length !== 0 ? tagsToDisplay.map(tag => {
      let value = get(tag, 'title.value') || get(tag, 'title.name');
      let name = get(tag, 'name');
      const quantity = facetValues[value] || facetValues[name];
      return quantity ? {
        key: value || name || '',
        label: quantity,
        name
      } : null;
    }).filter(item => item) : [Object.keys(facetValues).map(item => ({
      key: item,
      label: facetValues[item],
      name: item
    }))];
  }
  return filteredOptions;
};
const DropDownMultiselect = _ref => {
  let {
    filter,
    algoliaResponcedFacetValues,
    closeMobileOpener,
    setValue,
    value,
    clearText,
    ctaText,
    setListingFilter,
    externalVisible,
    setExternalVisible,
    analyticButtonCallback,
    analyticCheckboxCallback,
    resetAndSubmitFilters,
    withMapModalView = false
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const history = useHistory();
  const labelText = get(filter, 'title.jss.value');
  const tagsToDisplay = get(filter, 'tagsToDisplay.values');
  const facetName = get(filter, 'fieldNameItem.item.fieldName.value');
  const [localValues, setLocalValues] = useState([...value]);
  const fieldOpenedRef = useRef(null);
  const filterName = get(filter, 'name') || '';
  const fieldId = filterName ? filterName.toLowerCase().replace(/ /g, '-') : '';
  const [filteredOptions, setfilteredOptions] = useState([]);
  const [fieldVisible, setFieldVisible] = useState(false);
  useEffect(() => {
    setfilteredOptions(createFacets(tagsToDisplay, algoliaResponcedFacetValues));
  }, [algoliaResponcedFacetValues, tagsToDisplay]);
  useEffect(() => {
    setLocalValues([...value]);
  }, [value]);
  const commonSubmit = selectedFields => {
    closeMobileOpener();
    addQueryStringMultiple(facetName, selectedFields, history);
    setListingFilter();
    setFieldVisible(false);
  };
  const submitFilter = () => {
    const selected = {};
    filteredOptions.forEach(_ref2 => {
      let {
        key
      } = _ref2;
      selected[key] = localValues.includes(key);
    });
    const newValue = {
      value: [...localValues]
    };
    setValue(newValue);
    analyticButtonCallback(filterName, newValue);
    commonSubmit(selected);
  };
  const clearFilter = () => {
    const selected = {};
    filteredOptions.forEach(_ref3 => {
      let {
        key
      } = _ref3;
      selected[key] = false;
    });
    setLocalValues([]);
    setValue({
      value: []
    });
    if (Object.keys(selected).length === 0) {
      resetAndSubmitFilters();
      closeMobileOpener();
      setFieldVisible(false);
    } else {
      commonSubmit(selected);
    }
  };
  const hideDD = e => {
    if (fieldOpenedRef.current) {
      const mobileDevice = withMapModalView ? true : window.matchMedia(`(max-width: 991px)`).matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest(`#${fieldId}`)) return;
      }
      setFieldVisible(false);
    }
  };
  useEffect(() => {
    fieldOpenedRef.current = fieldVisible;
  }, [fieldVisible]);
  useEffect(() => {
    if (externalVisible && externalVisible === filterName) {
      setFieldVisible(true);
      setExternalVisible('');
    }
  }, [externalVisible, filterName, setExternalVisible]);
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return () => {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    id: fieldId
  }, /*#__PURE__*/React.createElement("div", {
    className: `button d-none d-lg-flex ${fieldVisible ? 'button--active' : ''}`,
    onClick: () => {
      setFieldVisible(!fieldVisible);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "button__text"
  }, labelText), /*#__PURE__*/React.createElement(IconChevronDown, null)), fieldVisible && /*#__PURE__*/React.createElement("div", {
    className: `dropdown ${filteredOptions.length && filteredOptions.length > 8 ? "dropdown--scrollable" : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: () => {
      setFieldVisible(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, labelText), /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: clearFilter
  }, clearText)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body__clear d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn-link",
    onClick: clearFilter
  }, clearText)), filteredOptions.map((singleValue, index) => {
    const tagValue = singleValue.key;
    const idKey = `${facetName}_${singleValue.key.replace(/\s/g, '_')}`;
    return /*#__PURE__*/React.createElement("label", {
      className: "fp__inner-label",
      htmlFor: idKey,
      key: `${facetName}_${index}`
    }, /*#__PURE__*/React.createElement("input", {
      checked: localValues.includes(tagValue),
      className: "input-choice fp__checkbox",
      type: "checkbox",
      value: tagValue,
      id: idKey,
      onChange: () => {
        if (tagValue && !localValues.includes(tagValue)) {
          analyticCheckboxCallback(`${filterName} : ${tagValue}`);
        }
        const newValues = localValues.includes(tagValue) ? localValues.filter(item => item !== tagValue) : [...localValues, tagValue];
        setLocalValues(newValues);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, singleValue.key, ' (', singleValue.label, ')'), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    disabled: false,
    onClick: submitFilter
  }, ctaText)))));
};
export default DropDownMultiselect;